import React, { Component } from 'react';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import URL from '../../Constants/URL'
import { GetStatusName } from '../../components/HelperComponents/StatusHelper';
import * as DKFDS from "dkfds";
import { CheckIssuedCardsVm } from '../../Models/CheckIssuedCardsVm';
import { ValidationType } from '../../Constants/ValidationTypes.ts';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';

export class SearchEuPerson extends Component {
  static displayName = SearchEuPerson.name;

  constructor(props) {
    super(props);
    this.toast = React.createRef();

    this.state = {
      // Input
      firstName: "",
      lastName: "",
      dateValue: "--",

      //Validation
      dateComplete: false,
      firstNameIsValid: false,
      lastNameIsValid: false,

      //ButtonPressed
      searchButtonPressed: false,

      showSpinner: false,

      CheckIssuedCardsVm: new CheckIssuedCardsVm(),

      euTableResults: [],
      euAnswers: {
        "Found": 0,
        "NotFound": 0,
        "NotAvailable": 0,
        "TimeOut": 0,
      },

    };
  }

  componentDidMount() {
    DKFDS.init();
  }

  validatePage() {
    if (this.state.dateComplete && this.state.firstNameIsValid && this.state.lastNameIsValid) {
      return true;
    } else {
      return false;
    }
  }

  fetchDriverFromEU() {
    this.setState({ searchButtonPressed: true })
    let v = this.validatePage()
    if (v) {
      this.clearPage(false)
      this.setState({ showSpinner: true })
      fetchModel("GET", URL + "/api/drivercard/GetDriverCardsFromEuPerson/?firstname=" + this.state.firstName + "&lastname=" + this.state.lastName + "&birthdate=" + this.state.dateValue, "", CheckIssuedCardsVm)
        .then(model => {
          this.setState({ CheckIssuedCardsVm: model[0]}, () => {
            this.handleEuSearchResults()
          })
        })
        .catch(error => {
          this.showErrorToast(error, "et førerkort")
        }).finally(() => {
          this.setState({ showSpinner: false })
        })
    }
  }

  handleEuSearchResults() {
    let result = this.state.CheckIssuedCardsVm
    let euAnswers = this.state.euAnswers;
    let results = []
    euAnswers.NotFound = 0
    euAnswers.NotAvailable = 0
    euAnswers.Found = 0
    euAnswers.TimeOut = 0


    
    for (let i = 0; i < result.MemberStates.length; i++) {
      if (result.MemberStates[i].statusCode === "Found") {
        euAnswers.Found += 1
      }
      else if (result.MemberStates[i].statusCode === "NotFound") {
        euAnswers.NotFound += 1
      }
      else if (result.MemberStates[i].statusCode === "Timeout") {
        euAnswers.TimeOut += 1
      }
      else if (result.MemberStates[i].statusCode === "NotAvailable") {
        euAnswers.NotAvailable += 1
      }
      for (let j = 0; j < result.MemberStates[i].checkIssuedCardResultVm.length; j++) {
        results.push([
          result.MemberStates[i].checkIssuedCardResultVm[j].cardNumber,
          result.MemberStates[i].checkIssuedCardResultVm[j].firstName,
          result.MemberStates[i].checkIssuedCardResultVm[j].lastName,
          result.MemberStates[i].memberStateCode,
          result.MemberStates[i].checkIssuedCardResultVm[j].driverLicenseNumber,
          result.MemberStates[i].checkIssuedCardResultVm[j].cardFromDate.split(" ")[0].replaceAll("/","-"),
          result.MemberStates[i].checkIssuedCardResultVm[j].cardToDate.split(" ")[0].replaceAll("/","-"),
          GetStatusName(result.MemberStates[i].checkIssuedCardResultVm[j].cardStatus),
        ])
      }
    }
    
    if(euAnswers.Found === 0){
        this.toast.current.show("Førerkort", "Der kunne ikke findes et førerkort fra EU.", "warning")
    }

    this.setState({
      euTableResults: results,
      euAnswers: euAnswers
    })
  }

  showErrorToast(error) {
    this.setState({ showSpinner: false })
    if (error === "No result") {
      this.toast.current.show("Førerkort", "Der er sket en fejl i søgningen.", "error")
    }
    else if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke hente data fra EU, prøv at søge igen om lidt.", "error")
    }
    else {
      this.toast.current.show("Fejl", "Der er sket en fejl: " + error, "error")
    }
  }

  clearPage(clearInputs) {
    this.setState({
      showSpinner: false,

      CheckIssuedCardsVm: new CheckIssuedCardsVm(),

      euTableResults: [],
      euAnswers: {
        "Found": 0,
        "NotFound": 0,
        "NotAvailable": 0,
        "TimeOut": 0,
      },

    })
    if (clearInputs) {
      this.setState({
        firstName: "",
        lastName: "",
        dateValue: "--",
        dateComplete: false,
        firstNameIsValid: false,
        lastNameIsValid: false,
        searchButtonPressed: false,
      })
    }
  }

  render() {
    return (
      <>
        <Fstyr.Toast ref={this.toast} />
        <Fstyr.Segment
          title="Søg Førerkort"
          isPageTitle={true}
        >
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => this.clearPage(true)}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Angiv EU person"
        >
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%', maxWidth: 600, justifyContent: 'space-between' }}>
            <Fstyr.Input
              value={this.state.firstName}
              label="Fornavn"
              type="text"
              direction="row"
              onChange={(value) => this.setState({ firstName: value })}
              validation={true}
              validationType={ValidationType.textWithSpaces}
              errorBodyText={"Fornavn kan kun indeholde bogstaver og mellemrum"}
              errorExampleText={"F.eks. Jens Jensen"}
              setValid={(valid) => this.setState({ firstNameIsValid: valid })}
              buttonClicked={this.state.searchButtonPressed}
              onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
            />
            <Fstyr.Input
              value={this.state.lastName}
              direction='row'
              label="Efternavn"
              type={"text"}
              onChange={(value) => this.setState({ lastName: value })}
              validation={true}
              validationType={ValidationType.textWithSpaces}
              errorBodyText={"Efternavn kan kun indeholde bogstaver"}
              errorExampleText={"f.eks. Jensen"}
              setValid={(valid) => this.setState({ lastNameIsValid: valid })}
              buttonClicked={this.state.searchButtonPressed}
              onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
            />
            <Fstyr.DatePicker
              value={this.state.dateValue}
              setDateComplete={(value) => this.setState({ dateComplete: value })}
              label="Fødselsdato"
              direction="row"
              onChange={(value) => this.setState({ dateValue: value })}
              buttonClicked={this.state.searchButtonPressed}
              onEnteonEnterPressed={() => this.fetchDriverFromEU()}
              onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
            />
            <div className="fstyr-left-button-group">
              <Fstyr.Button
                label="Søg"
                onClick={() => this.fetchDriverFromEU()}
                disabled={this.state.showSpinner}
              />
              <div style={{ width: 20 }} />
              <Fstyr.Spinner
                show={this.state.showSpinner}
              />
            </div>
          </div>

        </Fstyr.Segment>
        <Fstyr.Segment
          title="EU resultater"
        >
          <Fstyr.Table
            headers={["Førerkortnr.", "Fornavn", "Efternavn", "Land", "Kørekortnr.", "Startdato", "Udløbsdato", "Status"]}
            data={this.state.euTableResults}
            note={global.config.isPolice ? "Chauffør har " + this.state.euTableResults.length + " registreringer på førerkort i EU" : "Ansøger har " + this.state.euTableResults.length + " registreringer på førerkort i EU"}
            tableName="euResultsTable"
          />
          <div className="alert alert-info">
            <div className="alert-body">
              <p className="alert-heading">EU svar</p>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.Found}</p>
                <p className="alert-text">Found</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.NotFound}</p>
                <p className="alert-text">NotFound</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.NotAvailable}</p>
                <p className="alert-text">NotAvailable</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <p style={{ width: '50px' }} className="alert-text">{this.state.euAnswers.TimeOut}</p>
                <p className="alert-text">Timeout</p>
              </div>
            </div>
          </div>
        </Fstyr.Segment>
      </>
    );
  }
}
